import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const items = [
  "Bookkeeping & Accounting",
  "Tax Preparation & Planning",
  "Fractional CFO & Controller",
  "Career Coaching",
  "Financial Solution Strategies",
  "Nonprofit & Healthcare Finance",
  "Audit Readiness",
];

export default function ServicesMarquee() {
  return (
    <div className="border-y border-linen bg-white/50 py-6" data-testid="services-marquee">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-serif text-2xl italic text-pine/80 md:text-3xl">{item}</span>
            <Asterisk size={20} className="text-terra" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
